import React, { useCallback } from 'react';

import FlatTreeMavenirNode
	from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/FlatTreeMavenir/FlatTreeMavenirNodeWrapper/FlatTreeMavenirNode/FlatTreeMavenirNode';

import { IFlatMoTreeNode } from '@interfaces/components/tree';

import { FLAT_TREE_CHECKBOX_PADDING, FLAT_TREE_NODE_PADDING } from '@components/common/FlatTree/constants';

interface IFlatTreeMavenirNodeWrapperProps {
	node: IFlatMoTreeNode;
	onSkip: (id: string) => void;
	onSelect: (item: IFlatMoTreeNode, selected: string, isChecked: boolean) => void;
	index: string;
	onCollapse: (id: string, path: string) => void;
	getCheckboxLabel?: (value: boolean) => string;
	isCollapsed?: boolean;
	isReadOnly?: boolean;
	isSingleSelectMode?: boolean;
	style?: React.CSSProperties;
	isWithFolderIcon?: boolean;
	isDisabled?: boolean;
}

const FlatTreeMavenirNodeWrapper = ({
	node,
	onSkip,
	onSelect,
	onCollapse,
	isReadOnly,
	index,
	getCheckboxLabel,
	isSingleSelectMode,
	style,
	isWithFolderIcon,
	isDisabled,
}: IFlatTreeMavenirNodeWrapperProps) => {
	const paddingSize = FLAT_TREE_NODE_PADDING * node.depth + (node.nodeType ? 0 : FLAT_TREE_CHECKBOX_PADDING);

	const toggleCollapse = useCallback(() => onCollapse(index, node.path), [node.path, index, onCollapse]);

	const skipNodeHandler = useCallback(() => {
		node?.order !== undefined && onSkip(node.id);
	}, [node, onSkip]);

	return (
		<>
			<div style={{ ...style, paddingLeft: paddingSize }}>
				<FlatTreeMavenirNode
					getCheckboxLabel={getCheckboxLabel}
					index={index}
					isCollapsed={node.isHiddenChildren}
					isDisabled={isDisabled}
					isReadOnly={isReadOnly}
					isSingleSelectMode={isSingleSelectMode}
					isWithFolderIcon={isWithFolderIcon}
					node={node}
					onSelect={onSelect}
					skipNodeHandler={skipNodeHandler}
					toggleCollapse={toggleCollapse}
				/>
			</div>

		</>
	);
};

export default FlatTreeMavenirNodeWrapper;
